// extracted by mini-css-extract-plugin
export default {"fullWidth":"Zn-z","image":"_n-z","lazyLoadPicture":"ao-z","lazyLoadSpinner":"bo-z","lazyLoadSpin":"co-z","lazyLoadImage":"do-z","hasStyledAspectRatio":"eo-z"};